import React, { Component } from 'react';
import { DataContext } from './DataProvider';

function withDataConsumer(WrappedComponent) {
  return class extends Component {
    render() {
      return (
        <DataContext.Consumer>
          {context => {
            return (
              <WrappedComponent {...this.props} context={context} />
            );
          }}
        </DataContext.Consumer>
      );
    }
  };
}

export default withDataConsumer;



// WEBPACK FOOTER //
// ./src/api/contextApi/withDataConsumer.js